export default __webpack_public_path__ + "static/media/icon-google.38b2999b.svg";